import { render } from "./StickyItem.vue?vue&type=template&id=2d000d15&ts=true"
import script from "./StickyItem.vue?vue&type=script&lang=ts"
export * from "./StickyItem.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/bizerba/bizerba-web/light-modules/bizerba/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__